<template>
    <v-container fluid>
      <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        :top="true"
        :right="true"
        :timeout="0"
        absolute
      >
        {{ message }}
        <v-btn
          dark
          text
          @click="snackbar = false"
        >
          CLOSE
        </v-btn>
      </v-snackbar>
        <v-row>
   
      <v-col cols="1">
        <h2 class="white--text"> Organisations </h2>
      </v-col>
      <v-spacer></v-spacer>
	  
    </v-row>
    <v-spacer></v-spacer>
  
      <v-layout>
        <v-flex>
          <v-card>
            <v-tabs
              v-model="selectedTab"
              class="no-border-tabs"
            >
  
              <v-tab value="1" key="allOrganisations">All Organisations</v-tab>
              <v-tab value="2" key="creationRequests" >Creation Requests</v-tab>
              <v-tab value="3" key="updateRequests" >Update Requests</v-tab>
              <v-tab value="4" key="allRequests">All requests</v-tab>
              <v-tab value="5" key="auditTrail">Audit Trail</v-tab>
  
            </v-tabs>
  
            <v-tabs-items v-model="selectedTab">
  
              <v-tab-item key="allOrganisations">
                <allOrganisations/>
              </v-tab-item>
              <v-tab-item key="creationRequests">
                <creationRequests/>
              </v-tab-item>
              <v-tab-item key="updateRequests">
                <updateRequests/>
              </v-tab-item>
              <v-tab-item key="allRequests">
                <allRequests/>
                
              </v-tab-item>
              <v-tab-item key="auditTrail">
                <auditTrail/>
                
              </v-tab-item>
  
            </v-tabs-items>
  
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </template>
  <script>
  
  import creationRequests from '@/components/views/organization/creationrequests.vue'
  import allOrganisations from '@/components/views/organization/vieworganization.vue'
  import updateRequests from '@/components/views/organization/updaterequests.vue'
  import allRequests from '@/components/views/organization/allrequests.vue'
  import auditTrail from '@/components/views/organization/audittrail.vue'
  import store from '../../../store'
  
  export default {
      name: 'view_loan_requests',
      components: {
        updateRequests,
          allOrganisations,
          creationRequests,
          allRequests,
          auditTrail
      },
      mounted(){
        this.permissions = store.state.user.roleId.permissions;
      },
  
      data: function () {
          return {
              selectedTab: null,
              items: [],
              message: '',
              loading: false,
              snackbar: false,
              snackbarColor: '',
              messsage: '',
              // permissions: [],
              permissions: [],
              // selectedTab: '1',


  
          }
      },
    //   methods:{
    //     hasPerm (permission) {
		// 	return this.permissions.includes(permission)
		// },
    //   },
    //   computed:{
    //     canCreateOrg () {
		// 	if (this.hasPerm('CAN_CREATE_ORGANISATION')) {
    //     console.log('true')
		// 		return true
		// 	} else {
    //     console.log('false')
		// 		return false
		// 	}
		// },
		// canViewOrg () {
		// 	if (
		// 		this.hasPerm('CAN_VIEW_ORGANISATION') ||
    //     this.hasPerm('CAN_UPDATE_ORGANISATION')
		// 	) {
		// 		return true
		// 	} else {
		// 		return false
		// 	}
		// },
		// canApproveOrg () {
		// 	if (this.hasPerm('CAN_APPROVE_ORGANISATION')) {
		// 		return true
		// 	} else {
		// 		return false
		// 	}
		// },
    //   }

    methods: {
  hasPerm(permission) {
    console.log('Checking permission for:', permission);
    console.log('Permissions available:', this.permissions);
    return this.permissions.includes(permission);
  }
},
computed: {
  canViewOrg () {
			  if (
				  this.hasPerm('CAN_VIEW_ORGANISATION')
			  ) {
				  return true
			  } else {
				  return false
			  }
		  },
      // canApproveOrg () {
			//   if (
			// 	  this.hasPerm('CAN_APPROVE_ORGANISATION')
			//   ) {
			// 	  return true
			//   } else {
			// 	  return false
			//   }
		  // },

  // canApproveOrg() {
  //   const canView = this.hasPerm('CAN_APPROVE_ORGANISATION') ;
  //   console.log('canViewOrg:', canView);
  //   return canView;
  // },
  // canReadAuditOrg() {
  //   const canView = this.hasPerm('CAN_APPROVE_ORGANISATION') || this.hasPerm('CAN_UPDATE_ORGANISATION');
  //   console.log('canViewOrg:', canView);
  //   return canView;
  // }
}

  
  }
  
  </script>
  <style scoped>
  </style>
  